import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { CompanyModule } from '../company/company.module';
import { BiMessage } from '../entity/bi-message.entity';
import { CompanyBiMessage } from '../entity/company-bi-message.entity';
import { ModuleModule } from '../module/module.module';
import { BiMessageController } from './bi-message.controller';
import { BiMessageService } from './bi-message.service';
import { ExcelImportAdapter } from '../../../../whatsapp-broad-cast/src/app/whatsapp-broad-cast/adapter/excel-import.adapter';
import { WhatsappLogEntity } from '../entity/whats-app-log.entity';
import { WhatsAppMetaService } from '@schemax-whatsapp/shared-services/whatsapp-api';

@Module({
  imports: [
    TypeOrmModule.forFeature([
        BiMessage, 
        CompanyBiMessage,
        WhatsappLogEntity
    ]),
    forwardRef(()=> CompanyModule),
    forwardRef(()=> ModuleModule)
  ],
  controllers: [BiMessageController],
  providers: [BiMessageService, ApplicationExceptionHandler,ExcelImportAdapter,WhatsAppMetaService],
  exports: [BiMessageService,WhatsAppMetaService]
})
export class BiMessageModule {}


